var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01685 0.0022964H4.60693V2.36759H2.48535V11.6336H12.5073V9.73559H14.9927V14H0V0.0022964H1.01685ZM15 0H6.50635L9.4043 2.66153L5.31372 6.508L7.90405 8.94448L11.9946 5.09801L15 7.86632V0Z",
    fill: "#3B0532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIco);
export default __webpack_public_path__ + "static/media/redirect-ico.027adbfae9b6c989fc9a53a995bed430.svg";
export { ForwardRef as ReactComponent };